import _ from "lodash";
import ZRegexX from "./ZRegexX";

class ZMarkdown {

  static BoldMatched(original, match){
    let rtn = original;

    if(!_.isEmpty(match)){
  
      try{
        match = ZRegexX.Escape(match);
        match = match?.trim?.();
        rtn = original.replace(new RegExp(match, "gi"), "**$&**");
        rtn = ZRegexX.EscapeHeader(rtn);
        rtn = rtn.replace(/\*\*\*\*/gi, "");
      }catch{};

    }else{
      try{
        rtn = ZRegexX.EscapeHeader(rtn);
      }catch{};
    }
    
    return rtn;
  }

}

export default ZMarkdown;